module.exports = __webpack_public_path__ + "static/media/payment-bri.0a77bb45.png";